import { theme } from 'antd';

import type { ThemeConfig } from 'antd';

export const lightTheme: ThemeConfig = {
  algorithm: [theme.defaultAlgorithm],
  token: {
    colorPrimary: '#700F94',
    colorText: '#2c2543',
    colorWarning: '#bd363b',
    colorError: '#bd363b',
    colorTextPlaceholder: '#667180',
    fontFamily: 'Inter',
    zIndexPopupBase: 3000,
    zIndexBase: 3000,
  },
  components: {
    Table: {
      borderColor: '#cccad7',
      headerBg: '#f2f2fb',
      headerSortActiveBg: '#f2f2fb',
      headerSortHoverBg: '#f2f2fb',
      bodySortBg: 'transparent',
      fontSize: 14,
      selectionColumnWidth: 10,
      rowSelectedBg: '#F5E8F9',
      rowSelectedHoverBg: '#E8C8F4',
    },
    Slider: {
      trackBg: '#fb9318',
      trackHoverBg: '#fb9318',
      handleColor: '#fb9318',
      handleActiveColor: '#fb9318',
    },
    Segmented: {
      motionDurationMid: '0.1s',
    },
    DatePicker: {
      colorPrimary: '#700F94',
      cellActiveWithRangeBg: '#efdbff',
      borderRadius: 6,
    },
    Input: {
      activeBorderColor: '#700F94',
    },
    Drawer: {
      paddingLG: 0,
    },
  },
};
